<template>

    <v-container fluid fill-height pa-0>
  
      <v-layout column fill-height ma-0 pa-0>
  
        <v-layout ref="barWrapper" fill-height ma-0 pa-0 >
  
          <v-flex xs12 >
  
            <v-layout fill-height column  ma-0 pa-0 >
             
              <scroll-area>
                <template slot="header">
  
                  <v-toolbar class="active" :height="44" flat dark>
                    <v-toolbar-title>
                      <span class="body-2 uppercase blacktext--text">{{ $t('self-diagnosis') }}</span>
                    </v-toolbar-title>
  
                    <v-layout fill-height justify-end align-center>
  
                      <v-tooltip v-if="!dataObj" dark color="secondary" bottom>
                        <v-btn icon flat slot="activator" 
                        :data-testid="$options.name + '__btn__' + 'onAdd'" 
                        @click="() => onAdd()">
                          <svg-icon
                            :color="'whblacktextite'"
                            :name="'add'"
                            width="20"
                          />
                        </v-btn>
                        <span>{{ $t('add') }}</span>
                      </v-tooltip>
  
                    </v-layout>
  
                  </v-toolbar>
  
                </template>
  
                <template slot="body">
  
                  <v-layout column fill-height justify-start ma-0 pa-0 >
  
                    <scroll-table
                      :data="getTable"
                      :options="getOptions"
                      :headUppercase="false"
                      :translate="true"
                      @select=""
                      @value="(payload)=>onSelect(payload)"
                      @remove=""
                    />
  
                  </v-layout>
  
                </template>
  
              </scroll-area>
            </v-layout>

          </v-flex>

            <create-location-bar
                :open="getCreateBarOpen"
                :data="getData"
                :onlyEmit="true"
                :defaultEntity="{
                    entity:'device',
                    type:{
                        id: 'server',
                        value: 'server'
                    },
                    name: 'NMS'
                }"
                @update="() => loadDevice()"
                @submit="(payload) => onCreate(payload)"
                @close="() => onCreateClose()"
            />

            <device-bar
                v-if="getDeviceBarOpen"
                :open="getDeviceBarOpen"
                :modalActive="getDataObj"
                modalMode
                @update="() => setup()"
                @load-devices=""
                @close="() => onDeviceBarClose()"
            />
          
        </v-layout>
  
      </v-layout>
  
    </v-container>
  
  </template>
  
  <script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import scrollTable from '@/nms/components/partials/scrolltable_new.vue'
import svgIcon from '@/nms/components/media/svg/static/svg-icon.vue'
import CreateLocationBar from '@/nms/pages/location/create-location-bar.vue'
import DeviceBar from '@/nms/pages/device/device-bar.vue'

// Типы
interface DialogState {
  open: boolean
  addMode: boolean
  data: any | null
}

interface BarState {
  create: {
    open: boolean
    addMode: boolean
    data: any | null
  }
  show: {
    open: boolean
    addMode: boolean
    data: any | null
  }
}

interface TableColumn {
  title: string
  value: string
  type: string
  width: string
  iconName?: string
}

interface TableData {
  columns: TableColumn[]
  rows: any[]
}

interface OptionsColumns {
  [key: string]: { width: string }
}

interface OptionsData {
  columns: OptionsColumns
}

interface ParentData {
  $id?: string
  children?: any[]
  [key: string]: any
}

interface CreateData {
  data?: any
  entity?: string
  [key: string]: any
}

interface CmdbQueryResponse {
  children?: any[]
  [key: string]: any
}

export default Vue.extend({
  name: 'SELF_DIAGNOSIS',

  components: {
    scrollArea,
    scrollTable,
    svgIcon,
    CreateLocationBar,
    DeviceBar
  },

  props: {},

  data(): {
    dialog: DialogState
    bar: BarState
    edit: boolean
    parent: ParentData | null
    dataObj: any | null
    model: Record<string, any>
    options: OptionsData
    search: string
    table: TableData
  } {
    return {
      dialog: {
        open: false,
        addMode: false,
        data: null,
      },
      bar: {
        create: {
          open: false,
          addMode: false,
          data: null,
        },
        show: {
          open: false,
          addMode: false,
          data: null,
        },
      },
      edit: false,
      parent: null,
      dataObj: null,
      model: {},
      options: {
        columns: {
          text: { width: '40%' },
          timestamp: { width: '40%' },
          actions: { width: '40%' },
          check: { width: '20%' },
          check_dependence: { width: '5%' },
        },
      },
      search: '',
      table: {
        columns: [
          {
            title: 'device',
            value: 'name',
            type: 'text',
            width: '20%'
          },
          {
            title: 'template',
            value: 'template',
            type: 'text',
            width: '20%'
          },
          {
            title: 'state',
            value: '$id',
            type: 'icon',
            iconName: 'circle',
            width: '10%'
          },
          {
            title: 'ip address',
            value: 'ip_address',
            type: 'text',
            width: '10%'
          },
          {
            title: 'serial number',
            value: 'serial_number',
            type: 'text',
            width: '10%'
          },
        ],
        rows: [],
      },
    }
  },

  computed: {
    getData(): ParentData | null {
      return this.parent
    },

    getDataObj(): any | null {
      return this.dataObj
    },

    getCreateBarOpen(): boolean {
      return this.bar.create.open
    },

    getDeviceBarOpen(): boolean {
      return this.bar.show.open
    },

    getTable(): TableData {
      const t = this.$merge({}, this.table) as TableData

      if (this.search.length) {
        const searchLower = this.search.toLowerCase()
        t.rows = t.rows.filter(row => {
          return row.name?.toLowerCase().indexOf(searchLower) > -1
        })
        return t
      }
      return this.table
    },

    getOptions(): OptionsData {
      return this.options
    },
  },

  created(): void {
    this.setup()
  },

  methods: {
    setup(): void {
      this.statusUnsubscribe('SELF_DIAGNOSIS')
      this.loadDevice()
    },

    async loadDevice(): Promise<ParentData | undefined> {
      console.log(this.$options.name, 'loadDevice', 'START')
      try {
        const i = '/diagnostic'
        const query = {
          id: [i],
          data: {
            namePath: true,
            children: {
              data: {
                children: true,
                namePath: true,
                tags: true,
              },
              filter: { cls: { nin: ['folder'] } },
              tags: true,
            },
          }
        }
        const parent = await this.$bridge.cmdbQuery(query) as CmdbQueryResponse[]
        console.log(this.$options.name, 'loadDevice', 'parent', parent)

        if (parent?.length) {
          this.parent = parent[0]
          console.log(this.$options.name, 'loadDevice', 'this.parent', this.parent)

          if (this.parent.children?.length) {
            this.dataObj = this.parent.children[0]
            this.$set(this.table, 'rows', [this.dataObj])
            console.log(this.$options.name, 'loadDevice', 'rows', this.table.rows)
            this.statusSubscribe([this.dataObj], 'SELF_DIAGNOSIS')
          }
        }
        else {
          this.$dialog.notify.error('Папка diagnostic не найдена!', { timeout: 1000 })
        }
        return this.parent || undefined
      } catch (error) {
        console.error(this.$options.name, 'loadDevice smth wrong', error)
        return undefined
      }
    },

    onAdd(): void {
      console.log(this.$options.name, 'onAdd')
      this.$set(this.bar.create, 'open', true)
      this.edit = true
    },

    onSelect(val: any): void {
      if (val) {
        console.log(this.$options.name, 'onSelect', 'val', val)
        this.edit = false
        this.$set(this.bar.show, 'open', true)
        console.log(this.$options.name, 'onSelect', 'this.bar.show.open', this.bar.show.open)
      }
    },

    onCreateClose(): void {
      this.edit = false
      this.$set(this.bar.create, 'open', false)
    },

    onDeviceBarClose(): void {
      this.edit = false
      this.$set(this.bar.show, 'open', false)
    },

    async onUpdate(val: any): Promise<void> {
      console.log(this.$options.name, 'onUpdate', 'val', val)
      if (!val?.$id) return

      try {
        const user = await this.$bridge.getObjectById(val.$id)
        console.log(this.$options.name, 'onUpdate', 'user', user)

        if (user) {
          const data$ = val
          const u = await user.update(data$)
          if (u) {
            console.log(this.$options.name, 'onUpdate', 'u', u)
            this.$dialog.notify.success(this.$getTranslate('update success'), { timeout: 5000 })
            this.setup()
          } else {
            this.$dialog.notify.success('Ошибка обновления', { timeout: 5000 })
            console.error('CATCH', 'SELF_DIAGNOSIS', 'onUpdate', 'smth wrong')
          }
        }
      } catch (error) {
        this.$errorHandler(error)
        console.error(this.$options.name, 'onUpdate smth wrong', error)
      }
    },

    async onCreate(val: CreateData): Promise<void> {
      console.log(this.$options.name, 'onCreate', 'val', val)

      try {
        if (!val.data || !val.entity) return

        let parent$ = this.parent || await this.loadDevice()
        if (!parent$) return

        if (parent$?.children?.length) {
          for (const obj of parent$.children) {
            await obj.delete()
          }
        }

        this.setLoader('onCreate', true)
        const c = await parent$.createChild(val.entity, val.data)

        if (c) {
          this.$bridge.litePolling(c.$id)
          await this.loadDevice()
          this.$dialog.notify.success('Успешно создано', { timeout: 5000 })
        } else {
          this.$dialog.notify.error('Элемент не обновлён', { timeout: 5000 })
          console.log(this.$options.name, 'submit', 'smth wrong', c)
        }
        this.setLoader('onCreate', false)
      } catch (error) {
        console.error(this.$options.name, 'onCreate smth wrong', error)
        this.$errorHandler(error)
        this.setLoader('onCreate', false)
      }
    },

    async statusSubscribe(arr: any[], group: string): Promise<void> {
      this.$store.dispatch('measuresSubscribeInit', {
        handler: this.subscribeHandler,
        name: 'addStatus',
        group: group,
        listener: 'status'
      })

      if (arr.length) {
        arr.forEach(item => {
          if (item.$id) {
            this.$store.dispatch('addStatusKey', item)
          }
        })
        await this.$bridge.subscribe(arr.map(obj => obj.$id))
      }
    },

    subscribeHandler(e: { $id?: string; [key: string]: any }): void {
      if (e.$id) {
        this.$store.dispatch('addStatus', e)
      }
    },

    statusUnsubscribe(group: string): void {
      this.$store.dispatch('measuresSubscribeClose', {
        handler: this.subscribeHandler,
        group: group,
        listener: 'status'
      })
    },

    setLoader(name: string, status: boolean): void {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })
    },

    reset(): void {
      this.dialog = {
        open: false,
        addMode: false,
        data: null,
      }
      this.bar = {
        create: {
          open: false,
          addMode: false,
          data: null,
        },
        show: {
          open: false,
          addMode: false,
          data: null,
        },
      }
      this.dataObj = null
    },
  },
})
</script>
  
  <style lang="css" scoped>
  </style>
  